import { createVNode as l, mergeProps as i } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ExclamationCircleFilledStandard.js";
import n from "../components/PfIcon.js";
const r = (t, a) => {
  const e = {
    ...t,
    ...a.attrs
  };
  return l(n, i(e, {
    icon: o
  }), null);
};
r.displayName = "ExclamationCircleFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
